import { lazy } from 'react';

const HrRequests = lazy(() => import('./HrRequests'));

export default HrRequests;
